import { formatNumberMix } from '@/utils'

export default {
  data() {},
  methods: {
    getCardConfig(data = {}) {
      let list = new Array(4).fill(null)
      list[0] = {
        title: this.$t('ocean-bi::sc-analysis::totalCostRate'),
        count: data && this.$dataCheck(formatNumberMix(data.totalCostRate, 2, ',', '%')),
        noDetail: true,
        edit: this.editCard,
        tooltip: this.$t('ocean-bi::sc-analysis::totalCostRate-tips')
      }
      list[1] = {
        title: this.$t('ocean-bi::sc-analysis::shipmentRate'),
        count: data && this.$dataCheck(formatNumberMix(data.shipmentRate, 2, ',', '%')),
        noDetail: true,
        tooltip: this.$t('ocean-bi::sc-analysis::shipmentRate-tips')
      }
      list[2] = {
        title: this.$t('ocean-bi::sc-analysis::internetRate'),
        count: data && this.$dataCheck(formatNumberMix(data.internetRate, 2, ',', '%')),
        noDetail: true,
        tooltip: this.$t('ocean-bi::sc-analysis::internetRate-tips'),
      }
      list[3] = {
        title: this.$t('ocean-bi::sc-analysis::stockoutRate'),
        count: data && this.$dataCheck(formatNumberMix(data.stockoutRate, 2, ',', '%')),
        noDetail: true,
        tooltip: this.$t('ocean-bi::sc-analysis::stockoutRate-tips'),
      }
      return list
    },
    getDistributionConfig(data = []) {
      return {
        type: 'line',
        title: this.$t('ocean-bi::sc-analysis::配货情况'),
        ref: 'lineChart',
        height: '275px',
        tooltip: this.$t('ocean-bi::sc-analysis::chart-tooltip'),
        chart: {
          tooltip: {
            trigger: 'axis',
            formatter: (params, ticket, callback) => {
              return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span><span>${params[0].name}</span><br/>
              <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params[0].color}"></span><span>${params[0].seriesName}  </span><span style="font-weight:900;">${params[0].value}%</span>`
            }
          },
          legend: {
            data: [this.$t('ocean-bi::sc-analysis::five-day-distRate')]
          },
          xAxis: {
            data: data.map(item => item.dataDate)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#999999',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#999999'
              }
            }
          ],
          series: [
            {
              name: this.$t('ocean-bi::sc-analysis::five-day-distRate'),
              type: 'line',
              data: data.map(item => item.distRate)
            }
          ]
        }
      }
    },
    getInternetConfig(data = []) {
      return {
        type: 'line',
        title: this.$t('ocean-bi::sc-analysis::上网情况'),
        ref: 'lineChart',
        height: '275px',
        tooltip: this.$t('ocean-bi::sc-analysis::chart-tooltip'),
        chart: {
          tooltip: {
            trigger: 'axis',
            formatter: (params, ticket, callback) => {
              return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span><span>${params[0].name}</span><br/>
              <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params[0].color}"></span><span>${params[0].seriesName}  </span><span style="font-weight:900;">${params[0].value}%</span>`
            }
          },
          legend: {
            data: [this.$t('ocean-bi::sc-analysis::上网率')]
          },
          xAxis: {
            data: data.map(item => item.dataDate)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#999999',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#999999'
              }
            }
          ],
          series: [
            {
              name: this.$t('ocean-bi::sc-analysis::上网率'),
              type: 'line',
              data: data.map(item => item.internetRate)
            }
          ]
        }
      }
    },
    getReceiveConfig(data = []) {
      return {
        type: 'line',
        title: this.$t('ocean-bi::sc-analysis::妥投情况'),
        ref: 'lineChart',
        height: '275px',
        tooltip: this.$t('ocean-bi::sc-analysis::chart-tooltip'),
        chart: {
          tooltip: {
            trigger: 'axis',
            formatter: (params, ticket, callback) => {
              return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span><span>${params[0].name}</span><br/>
              <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params[0].color}"></span><span>${params[0].seriesName}  </span><span style="font-weight:900;">${params[0].value}%</span>`
            }
          },
          legend: {
            data: [this.$t('ocean-bi::sc-analysis::receiveRate')]
          },
          xAxis: {
            data: data.map(item => item.dataDate)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#999999',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#999999'
              }
            }
          ],
          series: [
            {
              name: this.$t('ocean-bi::sc-analysis::receiveRate'),
              type: 'line',
              data: data.map(item => item.receiveRate)
            }
          ]
        }
      }
    }
  }
}
